import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-reschedule-appointment',
  templateUrl: './reschedule-appointment.component.html',
  styleUrls: ['./reschedule-appointment.component.scss'],
})
export class RescheduleAppointmentComponent implements OnInit {
  datesToHighlight: any;
  slots: any;
  countryId: any;
  isLoading = false;
  Obj: any;
  bookingData: any;
  isCompleted = false;
  isChild = false;
  rescheduleData: any;
  rescheduleApplicantId: any;
  applicantId: any;
  completeReschedule: any;
  slotCheckCount:any;
  doctorId: any;
  doctorBranchId: any;
  patientId: any;
  isRevisit: boolean = false;

  constructor(private storage: StorageService, private apiService: ApiService, private spinner: NgxSpinnerService
  ) {

  }

  async getMonthSlots(year: number, month: number) {
    this.isLoading = true;
    const details = {
      'name': this.bookingData.name,
      'email': this.bookingData.email,
      'phone': this.bookingData.phone
    };

    if(this.bookingData.childs > 0) {
      this.isChild = true;
    }
    await this.apiService.getMonthSlots(month, this.isChild, this.doctorId, this.doctorBranchId).then((data: any) => {
      if (data.success === true) {
        // Showing spinner
    this.spinner.hide();
        this.apiService.monthSlots.next(data["data"].date);
        this.apiService.monthSlots.subscribe((data: any) => {
          this.datesToHighlight = data;
          this.isLoading = false;
        });
        this.getSlots();
      } else {
        this.isLoading = false;
        // Showing spinner
    this.spinner.hide();
      }
    });
  }
  
  getSlots() {
    this.isCompleted = true;
    this.apiService.getSlotsByDate(this.datesToHighlight[0],  this.isChild, this.doctorId, this.doctorBranchId, this.patientId, this.isRevisit).subscribe({
      next: (data: any) => {
        if (data.success == true) {
          //sorting by date and filtering by booking start and booking end date
          let currentDate = new Date();
          let slotData = data["data"].sort((firstEl: any, secondEl: any) => Date.parse(firstEl.start_time) - Date.parse(secondEl.start_time)).filter(
            (element: any) => currentDate >= new Date(element.time_limits.booking_start_time) && currentDate <= new Date(element.time_limits.booking_end_time)
          );
          slotData.forEach((element: any, index: number) => {
            if (this.slotCheckCount <= +element.available_slot_count) {
              slotData[index].slotsLimited = false;
            } else {
              slotData[index].slotsLimited = true;
            }
          });
          this.apiService.slots.next(slotData);
          this.apiService.slots.subscribe((data: any) => {
            this.slots = data;
          });
          this.apiService.isSlotsLoaded.next(true);
        } else {
          this.isLoading = false;
          this.apiService.isSlotsLoaded.next(false);
        }
      },

      error: (err: any) => {
        this.apiService.slots.next([]);
        this.apiService.isSlotsLoaded.next(false);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });

  }

  async ngOnInit() {
    // Showing spinner
    this.spinner.show();
    this.rescheduleData = JSON.parse(this.storage.get('km_reschedule_data') || '[]');
    // this.patientId = this.rescheduleData.bookingData.patient[0].id;
    this.doctorId = this.rescheduleData.bookingData.entity.id;
    this.doctorBranchId = this.rescheduleData.bookingData.branch.id;
    this.rescheduleApplicantId = this.storage.get('km_applicant_id');
    this.slotCheckCount = this.storage.get('km_applicant_count');
    this.bookingData = this.rescheduleData.bookingData;
    this.applicantId = this.rescheduleApplicantId;
    this.completeReschedule = this.rescheduleData.isEntireReschedule;
    this.countryId = this.bookingData.slot.entity_id;
    const newDate = new Date();
    const year = newDate.getFullYear();
    // Get the month index (0-based)
    const monthIndex = newDate.getMonth();
    // Convert to 1-based month (January is 1, December is 12)
    const month = monthIndex + 1;
    
    await this.getMonthSlots(year, month);
  }

}
